import React from "react";
import { Grid } from "@mui/material";
import { ProfilCardItem } from "../../../types";
import ProfilCard from "./ProfilCard";

type ProfilCardsListProps = {
    profilCardItems: ProfilCardItem[];
};

export default function ProfilCardsList({
    profilCardItems,
}: ProfilCardsListProps) {
    return (
        <Grid container spacing={2}>
            {profilCardItems.map(
                (profilCardItem: ProfilCardItem, index: number) => {
                    return (
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            key={index}
                            sx={{
                                display: "flex",

                                alignItems: "flex-start",
                                gap: "1rem",

                                flexDirection: "column",
                                width: "100%",
                            }}
                        >
                            <ProfilCard profilCardItem={profilCardItem} />
                        </Grid>
                    );
                }
            )}
        </Grid>
    );
}
